export const newsListFields = `
  id
  created_at
  language
  title
`;

export const newsListBasicFields = `
  id
  body
  created_at
  summary
  title
  thumbnail
`;

export const newsHubFields = `
  id
  body
  created_at
  featured_image
  language
  summary
  title
  thumbnail
`;
